<template>
  <div class="wecoupon-mall-list-fail">
    <div class="icon"></div>
    <div class="tips">{{ i18n('获取商圈下券信息失败，请重试') }}</div>
    <FitButton type="default" @click="handleClick">{{ i18n('重试') }}</FitButton>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue-demi';
import { FitButton } from '@tencent/wphk-ui';
import { i18n } from '../../../../i18n';

export default defineComponent({
  name: 'MallContentListFail',
  components: {
    FitButton,
  },
  emits: ['retry'],
  setup(props, context) {
    function handleClick() {
      context.emit('retry');
    }

    return {
      i18n,
      handleClick,
    };
  },
});
</script>

<style lang="less" scoped>
@import (reference) '../../../../less/main.less';

.wecoupon-mall-list-fail {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;

  .icon {
    margin-top: 38 / @rem;
    width: 130 / @rem;
    height: 130 / @rem;
    background-image: url(./assets/fail-icon.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }

  .tips {
    margin-top: 65 / @rem;
    min-height: 144 / @rem;

    color: #fff;
    text-align: center;
    font-family: PingFang HK;
    font-size: 32 / @rem;
    line-height: 48 / @rem;
  }

  .btn {
    margin-top: 48 / @rem;
  }
}
</style>
